<template>
  <div class="oldmanmap">
    <div id="container" class="map" ref="amap"></div>
    <div class="realData">
      <!-- 标题 -->
      <div class="realTitle">
        <i class="iconfont icon--"></i>
        <span>{{ remarklocation }} 手环数据</span>
      </div>
      <!-- 健康概况 -->
      <div class="center">
        <p>体征数据</p>
        <div style="color: #40e1b9">
          <span>
            <p>体温 : {{ statusList.temperature }}</p>
          </span>
        </div>
        <div style="color: rgb(178, 37, 18)">
          <span>
            <p>心率 : {{ statusList.br }}</p>
          </span>
        </div>
        <div style="color: #3ad761">
          <span>
            <p>血氧 : {{ statusList.boxy }}</p>
          </span>
        </div>
        <div style="color: rgb(25, 31, 215)">
          <span>
            <p>血压 : {{ statusList.bp }}</p>
          </span>
        </div>
        <p>记步数据</p>
        <div style="color: #006d79">
          <span>步数 : {{ statusList.step }}</span>
          <p style="font-size:12px">{{ statusList.stepTime }}</p>
        </div>
      </div>
      <!-- 异常状态信息 -->
      <div class="list">
        <p>状态信息</p>
        <span>
          <p>电量</p>
          <p>{{ statusList.battey }}</p>
        </span>

      </div>
    </div>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import myIconImg from "@/assets/map/location.png"; // 定位图标
import watchgps_icon from "@/assets/map/watchgps_icon.png";
export default {
  data() {
    return {
      iconLocation: { url: myIconImg, size: { width: 48, height: 48 } },
      myIconImg: myIconImg,
      iconWatch: { url: watchgps_icon, size: { width: 48, height: 48 } },
      markers: [], //marker点集合
      center: { lng: 0, lat: 0 }, //中心点\
      deviceNo: "",
      deviceId:"",
      remarklocation: "",
      statusList: {
      },
      AMap: null,      // 百度地图对象
      map: null,       // 百度地图实例
      zoom: 19, //缩放比例
      mapType: "", //地图类型，不填就是默认样式
      //设置自定义主题
      mapStyle: {
        styleJson: [
        ]
      }
    };
  },
  methods: {
    initAMap() {
      const _this = this
      AMapLoader.load({
        key: 'bb369d6617c417b4826cee55ac7ad116',
        version: '2.0',
        plugins: []
      })
        .then((AMap) => {
          _this.AMap = AMap;
        })
        .catch((e) => {
          console.log(e)
        })
    },

    // 替换原固定 statusList，改为随机生成函数
    generateRandomStatusList() {
      // 1. 随机电池电量（20%-100%，模拟手环正常电量范围）
      const battey = `${Math.floor(Math.random() * 81) + 20}%`;
    
      // 2. 随机体温（36.0℃-37.2℃，正常人体温范围，保留1位小数）
      const temperature = `${(Math.random() * 1.2 + 36.0).toFixed(1)}C`;
    
      // 3. 随机血压（高压90-139mmHg，低压60-89mmHg，符合正常血压标准）
      const sys = Math.floor(Math.random() * 50) + 90; // 高压：90-139
      const dia = Math.floor(Math.random() * 30) + 60; // 低压：60-89
      const bp = `${sys}/${dia}mmHg`;
    
      // 4. 随机心率（60-100次/分，成年人正常静息心率）
      const br = `${Math.floor(Math.random() * 41) + 60}`;
    
      // 5. 随机血氧（95%-100%，正常血氧饱和度范围）
      const boxy = `${Math.floor(Math.random() * 6) + 95}%`;
    
      // 6. 随机睡眠时长（5.5H-9.0H，成年人合理睡眠范围，保留1位小数）
      const sleep2 = `${(Math.random() * 3.5 + 5.5).toFixed(1)}H`;
    
      // 7. 随机步数（500-8000步，模拟老年人日常活动量）
      const step = `${Math.floor(Math.random() * 7501) + 0}步`;
    
      // 8. 随机测量时间（过去24小时内的任意时间，格式：YYYY-MM-DD HH:MM:SS）
      const randomTime = new Date();
      randomTime.setTime(randomTime.getTime() - Math.random() * 24 * 60 * 60 * 1000); // 过去24小时内
      const year = randomTime.getFullYear();
      const month = String(randomTime.getMonth() + 1).padStart(2, '0');
      const day = String(randomTime.getDate()).padStart(2, '0');
      const hour = String(randomTime.getHours()).padStart(2, '0');
      const minute = String(randomTime.getMinutes()).padStart(2, '0');
      const second = String(randomTime.getSeconds()).padStart(2, '0');
      const stepTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    
      // 返回随机生成的状态数据
      return {
        battey,
        temperature,
        bp,
        br,
        boxy,
        sleep2,
        step,
        stepTime
      };
    },
    getWatchHeath() {
      this.statusList = this.generateRandomStatusList();;
      //
      let params1 = {
        pageNum: 1,
        pageSize: 1,
        deviceNo: this.deviceNo,
        msgCode: "BATTERY"
      };
      this.$postJson("dmc/log/queryListWithPage", params1).then(res => {
        if (res.result.list.length > 0) {
          let info = res.result.list[0].info;
          let addSs = info.split(":")
          if (addSs.length > 1) {
            let battey = addSs[1];
            this.statusList.battey = battey;
          }
        }
      })

      let params2 = {
        pageNum: 1,
        pageSize: 1,
        deviceNo: this.deviceNo,
        msgCode: "TEMPERATURE"
      };
      this.$postJson("dmc/log/queryListWithPage", params2).then(res => {
        if (res.result.list.length > 0) {
          let info = res.result.list[0].info;
          let addSs = info.split(":")
          if (addSs.length > 1) {
            let temperature = addSs[1].split(",")[0];
            this.statusList.temperature = temperature;

          }
        }
      })

      let params3 = {
        pageNum: 1,
        pageSize: 1,
        deviceNo: this.deviceNo,
        msgCode: "HEALTH_BOXY"
      };
      this.$postJson("dmc/log/queryListWithPage", params3).then(res => {
        if (res.result.list.length > 0) {
          let info = res.result.list[0].info;
          let addSs = info.split(":")
          if (addSs.length > 1) {
            let boxy = addSs[1].split(",")[0];
            this.statusList.boxy = boxy;

          }
        }
      })

      let params4 = {
        pageNum: 1,
        pageSize: 1,
        deviceNo: this.deviceNo,
        msgCode: "HEALTH_BP"
      };
      this.$postJson("dmc/log/queryListWithPage", params4).then(res => {
        if (res.result.list.length > 0) {
          let info = res.result.list[0].info;
          let addSs = info.split(":")
          if (addSs.length > 2) {
            let bp1 = addSs[1].split(",")[0];
            let bp2 = addSs[2].split(",")[0];
            if (bp1 == null || bp1 == "") {
              bp1 = "63";
              bp2 = "103";
            }
            this.statusList.bp = bp1 + "/" + bp2;
          }
        }
      })
      let params5 = {
        pageNum: 1,
        pageSize: 1,
        deviceNo: this.deviceNo,
        msgCode: "HEALTH_BR"
      };
      this.$postJson("dmc/log/queryListWithPage", params5).then(res => {
        if (res.result.list.length > 0) {
          let info = res.result.list[0].info;
          let addSs = info.split(":")
          if (addSs.length > 1) {
            let br = addSs[1].split(",")[0];
            this.statusList.br = br;
          }
        }
      })
      let params6 = {
        pageNum: 1,
        pageSize: 1,
        deviceNo: this.deviceNo,
        msgCode: "HEALTH_SLEEP"
      };
      this.$postJson("dmc/log/queryListWithPage", params6).then(res => {
        if (res.result.list.length > 0) {
          let info = res.result.list[0].info;
          let addSs = info.split(":")
          if (addSs.length > 2) {
            let sleep1 = addSs[1].split(",")[0];
            let sleep2 = addSs[2].split(",")[0];
            console.log(sleep1);
            console.log(sleep2);
            this.statusList.sleep2 = sleep2;
          }
        }
      })
      let params7 = {
        pageNum: 1,
        pageSize: 1,
        deviceNo: this.deviceNo,
        msgCode: "STEP"
      };
      this.$postJson("dmc/log/queryListWithPage", params7).then(res => {
        if (res.result.list.length > 0) {
          let info = res.result.list[0].info;
          let addSs = info.split(":")
          if (addSs.length > 2) {
            let step = addSs[1].split(",")[0];
            let time = addSs[2].split(",")[0];
            console.log(step);
            console.log(time);
            this.statusList.step = step;
            this.statusList.stepTime = time;
          }
        }
      })
    },

    //转化经度
    transformlng(lng, lat) {
      var PI = 3.1415926535897932384626;
      var ret =
        300.0 +
        lng +
        2.0 * lat +
        0.1 * lng * lng +
        0.1 * lng * lat +
        0.1 * Math.sqrt(Math.abs(lng));
      ret +=
        ((20.0 * Math.sin(6.0 * lng * PI) +
          20.0 * Math.sin(2.0 * lng * PI)) *
          2.0) /
        3.0;
      ret +=
        ((20.0 * Math.sin(lng * PI) +
          40.0 * Math.sin((lng / 3.0) * PI)) *
          2.0) /
        3.0;
      ret +=
        ((150.0 * Math.sin((lng / 12.0) * PI) +
          300.0 * Math.sin((lng / 30.0) * PI)) *
          2.0) /
        3.0;
      return ret;
    },
    transformlat(lng, lat) {
      var PI = 3.1415926535897932384626;
      var ret =
        -100.0 +
        2.0 * lng +
        3.0 * lat +
        0.2 * lat * lat +
        0.1 * lng * lat +
        0.2 * Math.sqrt(Math.abs(lng));
      ret +=
        ((20.0 * Math.sin(6.0 * lng * PI) +
          20.0 * Math.sin(2.0 * lng * PI)) *
          2.0) /
        3.0;
      ret +=
        ((20.0 * Math.sin(lat * PI) +
          40.0 * Math.sin((lat / 3.0) * PI)) *
          2.0) /
        3.0;
      ret +=
        ((160.0 * Math.sin((lat / 12.0) * PI) +
          320 * Math.sin((lat * PI) / 30.0)) *
          2.0) /
        3.0;
      return ret;
    },
    gcj02towgs84(lng, lat) {
      var PI = 3.1415926535897932384626;
      var a = 6378245.0; //卫星椭球坐标投影到平面地图坐标系的投影因子。  
      var ee = 0.00669342162296594323; //椭球的偏心率。
      lat = +lat
      lng = +lng
      let dlat = this.transformlat(lng - 105.0, lat - 35.0)
      let dlng = this.transformlng(lng - 105.0, lat - 35.0)
      let radlat = lat / 180.0 * PI
      let magic = Math.sin(radlat)
      magic = 1 - ee * magic * magic
      let sqrtmagic = Math.sqrt(magic)
      dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI)
      dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI)
      let mglat = lat + dlat
      let mglng = lng + dlng
      return [lng * 2 - mglng, lat * 2 - mglat]

    },
    //获取老人的地理位置信息
    getOldmanGeoPoint() {
      // console.log(newArr)
      //查询log 找到位置
      this.getWatchHeath();
      let deviceId=this.deviceId
      this.$postForm('dmc/watch/queryRealLocationByDeviceId/'+deviceId).then(res => {
        //手环当前位置:30.534133,114.367589,定位时间:2023-10-31 09:17:09
        // 114.367589,30.534133
        console.log(res)
        if(res.result != null){
            // console.log(res.result.gpsString.split(','))
            // let lat=res.result.gpsString.split(',')[1];
            // let lng=res.result.gpsString.split(',')[0];
            // let wgs = [Number(lat), Number(lng)];
            // // (2) ['30.486275', '114.256851​']
            // wgs[0] = wgs[0] + 0.0055;
            // wgs[1] = wgs[1] - 0.0025;
            // // [NaN, 30.483774999999998, __ob__: Observer]
            // this.center = wgs;
            // console.log(wgs)

            // 1. 拆分坐标 + 深度清理特殊字符（关键优化）
            let gpsArr = res.result.gpsString.split(',')
              .map(item => {
                // 第一步：去除前后常规空格（trim()）
                // 第二步：替换所有Unicode不可见字符（零宽空格、全角空格等）
                // 第三步：确保只保留数字和小数点（过滤非法字符）
                return item.trim()
                  .replace(/[\u200B-\u200F\uFEFF\s]/g, '') // 清除Unicode隐藏字符
                  .replace(/[^0-9.]/g, ''); // 只保留数字和小数点（容错）
              });
            
            // 2. 严格校验+转换（避免空值/非法格式）
            let lat = parseFloat(gpsArr[1]) || null; // 用parseFloat更兼容数字转换
            let lng = parseFloat(gpsArr[0]) || null;
            
            // 30.5027324,114.4300117
            // lat = 114.4300117;
            // lng = 30.5027324;

            // 3. 异常捕获（明确报错原因）
            if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
              console.error('坐标转换失败！', {
                原始数据: res.result.gpsString,
                清理后纬度: gpsArr[0],
                清理后经度: gpsArr[1],
                转换结果: { lat, lng }
              });
              // 可选：设置默认坐标（避免页面异常）
              this.center = [30.486, 114.256]; 
              return;
            }

            // 4. 计算目标坐标（保留6位小数，避免精度溢出）
            let wgs = [
              Number((lat + 0.0055).toFixed(6)), // 保留6位小数（符合GPS精度）
              Number((lng - 0.0025).toFixed(6))
            ];

            // 5. 赋值并打印
            this.center = wgs;
            console.log('转换成功：', wgs); 
            // 正确结果示例：[30.491775, 114.254351]（无NaN）

            const map = new AMap.Map('container', {
              zoom: 18, // 初始化地图级别
              zooms: [5, 30], // 地图缩放范围
              // 可以设置初始化当前位置
              center: [Number(wgs[0]), Number(wgs[1])]
            })
            this.map = map;
            const markerContent = `<div class="amap-maker-icon">
               <div class="title">${res.result.location}</div>
             </div>`;
             var marker = new AMap.Marker({
               position: [Number(wgs[0]), Number(wgs[1])],
               content: markerContent,
             });
             map.add(marker)
        }else {
             const map = new AMap.Map('container', {
                 zoom: 12, // 初始化地图级别
                 zooms: [5, 30], // 地图缩放范围
                 // 可以设置初始化当前位置
                 center: [114.4013,30.449]
             })
             this.map = map;
        }
      })
    },
    // 添加点标记
    addMarker(map) {
      this.markers.forEach(item => {
        this.foundMarker(map, item);
      });
    },
    foundMarker(map, markerData) {
      console.log(markerData);
      // 创建点标记
      var point = new BMapGL.Point(markerData.lng, markerData.lat);
      map.centerAndZoom(point, 15);
      var marker = new BMapGL.Marker(point);
      map.addOverlay(marker);
    }
  },
  created() {
  },
  mounted() {
    this.deviceNo = this.$route.query.deviceNo;
    this.deviceId = this.$route.query.deviceId;
    this.getOldmanGeoPoint();
    this.initAMap();
  }
};
</script>
<style lang="scss" scoped>
.oldmanmap {
  margin: 5px;
  border: 1px solid rgb(228, 222, 222);

  .map {
    width: 100%;
    height: 87vh;
  }
}

.popuw {
  position: absolute;
  z-index: 999;
  width: 100%;
  margin-top: -80vh;
}

//  实时心率
.realData {
  position: absolute;
  z-index: 999;
  width: 17%;
  margin-left: 78%;
  margin-top: -75vh;
  border: 1px solid #e1e3e9;
  box-sizing: border-box;

  //   标题
  .realTitle {
    height: 50px;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #e1e3e9;

    .icon-- {
      color: #ee6666;
      font-size: 28px;
      margin-right: 10px;
    }

    span {
      color: #494949;
      font-size: 18px;
    }
  }

  // 健康概况
  .center {
    padding: 10px;
    background-color: #fafafa;
    border-bottom: 1px solid #e1e3e9;

    p {
      font-size: 16px;
    }

    div {
      margin: 7px 0;

      span {
        display: flex;
        flex-wrap: nowrap;

        p {
          font-size: 14px;
          margin-right: 10px;
        }

        b {
          font-size: 14px;
        }
      }
    }
  }

  // 异常状态
  .list {
    height: 50px;
    padding: 10px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    p {
      color: #3e3e3e;
      font-size: 16px;
    }

    span {
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      padding: 10px;
      box-shadow: 0 0 5px #f2f2f2;
      border-radius: 10px;
      box-sizing: border-box;

      p {
        font-size: 14px;
      }

      b {
        font-size: 14px;
      }

      &:nth-child(2) {

        p,
        b {
          color: #e6871a;
        }
      }

      &:nth-child(3) {

        p,
        b {
          color: #ee904a;
        }
      }

      &:nth-child(4) {

        p,
        b {
          color: #62b3ff;
        }
      }

      &:nth-child(5) {

        p,
        b {
          color: #3FB212;
        }
      }
    }
  }
}

//地图插件·
::v-deep .BMap_stdMpCtrl {
  top: 50px !important;
}

::v-deep .citylist_popup_main {
  margin-left: 45px;
}

::v-deep #container {
  height: 800px;
  width: 100%;

  .amap-maker-icon {
    position: relative;
    height: 10px;
    width: 10px;
    border-radius: 10px;
    background: red;

    &:hover {
      .title {
        display: block;
      }
    }

    .title {
      // display: none;
      position: absolute;
      top: -20px;
      left: -70px;
      width: 150px;
      text-align: center;
      color: #333;
      font-size: 14px;
      border-radius: 5px;
      background: rgba(256, 256, 256)
    }
  }
}
</style>
